<div class="breadcrumbs">
  <div class="breadcrumbs-content" [hidden]="!breadcrumbs || !breadcrumbs.length">
    <span class="me-2" *ngFor="let bc of breadcrumbs; index as i">
      <a title="{{ bc.label }}" (click)="redirectRefreshed(bc.url)" *ngIf="bc.url; else txtonly">{{ bc.label }}</a>
      <ng-template #txtonly>
        <span>{{ bc.label }}</span>
      </ng-template>
      <i class="ms-2 fa fa-angle-right" *ngIf="i < breadcrumbs.length - 1"></i>
    </span>
  </div>
</div>
